<script setup lang="ts">
defineProps<{
  isOpen: boolean
}>()
</script>

<template>
  <button :class="{ 'is--open': isOpen }" class="btn is--raw fTable__details-btn" type="button">
    <span>{{ $t('step_components.table_details') }}</span>
    <i class="ic-chevron-down" />
  </button>
</template>
